import React, { useState } from 'react';
import { authService } from '../services/authService';
import './LoginPage.css'; // Reusing login styles for consistency
import logo from '../assets/logo-lnv.jpeg';

const ForgotPasswordPage: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        if (!email) {
            return;
        }

        setLoading(true);
        setMessage(null);

        try {
            await authService.forgotPassword(email);
            // We always show success for security purposes
            setMessage('Si el correo está registrado, recibirás un enlace de recuperación en los próximos minutos.');
            setEmail('');
        } catch (err: any) {
            // Again, generic message for security
            setMessage('Si el correo está registrado, recibirás un enlace de recuperación en los próximos minutos.');
            setEmail('');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-container">
                <div className="login-card">
                    <div className="login-header">
                        <img src={logo} alt="LNV Logo" className="logo-img" />
                    </div>

                    <div className="login-content">
                        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#fff' }}>Recuperar Contraseña</h2>
                        <p style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#a3a3a3' }}>
                            Ingresa tu correo electrónico para recibir un enlace de recuperación.
                        </p>
                        
                        <form className="login-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <input
                                    id="email"
                                    type="email"
                                    placeholder="Email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    disabled={loading || message !== null}
                                    required
                                />
                            </div>

                            {message && (
                                <div className="success-message" style={{ color: '#bef264', marginBottom: '1rem', textAlign: 'center', backgroundColor: '#1e1e1e', padding: '10px', borderRadius: '5px' }}>
                                    {message}
                                </div>
                            )}

                            <button
                                type="submit"
                                className="login-submit-btn"
                                disabled={loading || message !== null || !email}
                            >
                                {loading ? (
                                    <div className="btn-loading">
                                        <div className="spinner"></div>
                                        <span>Enviando...</span>
                                    </div>
                                ) : (
                                    'Enviar Enlace'
                                )}
                            </button>
                        </form>

                        <div style={{ textAlign: 'center', marginTop: '1.5rem' }}>
                            <a href="/login" style={{ color: 'var(--accent)', fontWeight: 600 }}>
                                ← Volver al inicio de sesión
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
